import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsHandcycleNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.33 14.5a3.17 3.17 0 106.34 0 3.17 3.17 0 00-6.34 0zm3.17-1.83a1.83 1.83 0 110 3.66 1.83 1.83 0 010-3.66zm17-1.34a3.1 3.1 0 00-2.55 1.291l-3.29-1.77a.502.502 0 00.01-.121A1.67 1.67 0 1013 12.41a1.6 1.6 0 001.019-.369l1.774.959-.763 1.33H10a1 1 0 01-.9-.55L6.91 9.67H5.38l2.52 4.75a2.388 2.388 0 002.1 1.25h5.8l1.183-2.035.408.222c-.04.212-.061.427-.061.643a3.17 3.17 0 103.17-3.17zm0 5a1.83 1.83 0 110-3.66 1.83 1.83 0 010 3.66z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHandcycleNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsHandcycleNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsHandcycleNormalSmall;
